import { useMemo }            from 'react';
import { contentInfoType }    from 'types'
import ThumbUpIcon            from '@mui/icons-material/ThumbUp';
import ThumbUpOutlinedIcon    from '@mui/icons-material/ThumbUpOffAlt';
import { makeStyles }         from 'makeStyles';


const useStyles = makeStyles()(() => ({ 
      thumbs: {
      display:        'flex',
      justifyContent: 'flex-end',
      maxHeight:      30
    },
    icon: {
      marginLeft: 5,
      color:      '#FFF',
    },
    likes: {
      marginLeft: 3,
      color:      '#FFF',
      cursor:     'default',
    }
}))

type ThumbsProps = {
  id:              string;
  Iwidth:          number;
  activityUpdated: boolean;
  showLikes:       boolean;
  groupUrl:        boolean;
  disabled:        boolean;
  hash:            contentInfoType;
}

const Thumbs: React.FC<ThumbsProps> = ({
  id,
  activityUpdated,
  Iwidth,
  showLikes,
  hash,
  groupUrl,
  disabled,
}) => {
  
  // if (id === 'Decimal_square') {
  //   console.log('hash[id] : ', hash[id] )
  // }

  const { classes } = useStyles();

  const [rootStyle, iconStyle] = useMemo(() => {
    return [
      {
        maxWidth: Iwidth,
        minWidth: Iwidth,
      },
      {
        cursor: disabled ? 'default' : 'pointer',
        fontSize: 20
      }
    ]
  },[Iwidth, disabled])


  return (
      <div 
        className = { classes.thumbs }
        style     = { rootStyle }
      >
          {
             showLikes
             &&
             <div 
                className   = { classes.likes } 
                data-testid = { "likesNumber" }
             >
               { hash[id].totalLikes > 999 ? `(${ hash[id].totalLikes })` : `( ${ hash[id].totalLikes } )` } 
             </div>
           }
           {
             !groupUrl && activityUpdated && hash[id] && hash[id].liked !== 1
             &&
             <ThumbUpOutlinedIcon 
                 className   = { classes.icon }
                 style       = { iconStyle }
                 data-testid = { "ThumbUpOutlinedIcon" }
                 onClick     = { 
                  () => { 
                    if (disabled){ 
                      return 
                    }
                    import("functions/actions/handle_like").then(func => {
                      func.handleLike(id, 'like')
                    });
                 }}
             />
           }
           {
             !groupUrl && activityUpdated && hash[id] && hash[id].liked === 1
             &&
             <ThumbUpIcon 
                 className = { classes.icon }
                 style     = { iconStyle }
                 onClick   = { 
                  () => { 
                    if (disabled){ 
                      return 
                    }
                    import("functions/actions/handle_like").then(func => {
                      func.handleLike(id, 'dislike')
                    });
                 }}
             />
           }    
      </div>  
  );
}


export default Thumbs;



